export default "__VITE_ASSET__DHlDwfpL__"